function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { api } from '@signiapp/helpers';
import { PAGE_SIZE, MODULE_BASE_PATH } from "../scripts/constants";

var req = function req(url, options) {
  return api.req(/^http/.test(url) ? url : "".concat(MODULE_BASE_PATH).concat(url), options);
};

export var createContactList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(contactList, language) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", req('/contact-list', {
              method: 'POST',
              body: JSON.stringify({
                contactList: contactList,
                language: language,
                url: window.SIGNIAPP_FRONTEND_BASE_URL
              }),
              headers: {
                'Content-Type': 'application/json'
              }
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function createContactList(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var updateContactList = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(contactList, language) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", req("/contact-list/".concat(contactList.id), {
              method: 'PUT',
              body: JSON.stringify({
                contactList: contactList,
                language: language,
                url: window.SIGNIAPP_FRONTEND_BASE_URL
              }),
              headers: {
                'Content-Type': 'application/json'
              }
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function updateContactList(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
export var deleteContactList = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(id) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", req("/contact-list/".concat(id), {
              method: 'DELETE'
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function deleteContactList(_x5) {
    return _ref3.apply(this, arguments);
  };
}();
export var removeSharedContactList = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(id) {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", req("/contact-list/remove/".concat(id), {
              method: 'POST'
            }));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function removeSharedContactList(_x6) {
    return _ref4.apply(this, arguments);
  };
}();
export var getContactList = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(id) {
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", req("/contact-list/".concat(id)));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function getContactList(_x7) {
    return _ref5.apply(this, arguments);
  };
}();
export var getContactLists = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(wildcard) {
    var url, params;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            url = '/contact-list';
            params = new URLSearchParams();
            params.append('includeShared', true);

            if (wildcard) {
              params.append('wildcard', wildcard);
            }

            url += '?' + params.toString();
            return _context6.abrupt("return", req(url));

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function getContactLists(_x8) {
    return _ref6.apply(this, arguments);
  };
}();
export var getContactListContacts = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(id) {
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", req("/contact-list/".concat(id, "/contacts")));

          case 1:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function getContactListContacts(_x9) {
    return _ref7.apply(this, arguments);
  };
}();
export default {
  createContactList: createContactList,
  getContactList: getContactList,
  removeSharedContactList: removeSharedContactList,
  getContactLists: getContactLists,
  updateContactList: updateContactList,
  deleteContactList: deleteContactList,
  getContactListContacts: getContactListContacts
};